import { useConfirm } from "hooks/useConfirm"
import { useNotification } from "hooks/useNotification"
import moment from "moment"
import { useState } from "react"
import feathers from "utility/client"

export const RemoteRestart = (props) => {
  const {device, onRestart = () => {}} = props
  const confirm = useConfirm()
  const notify = useNotification()

  const [reloading, setReloading] = useState(false)

  const onRestartConfirmed = async () => {
    if (!device) {
      return
    }

    await feathers.service('device').patch(device, {
      restartedAt: moment().toISOString()
    })

    notify({
      notification: 'Device will reload soon!',
      variant: 'primary'
    })
  }

  const onRestartRequest = () => {
    confirm({
      title: `Confirm to proceed reload`,
      confirmTitle: 'Yes, Reload the device!',
      message: `Please confirm that you want to load the Video Window app in this device! The device will disconnect and reload the app internally without closing the app itself.`,
      onConfirm: async () => {
        setReloading(true)
        onRestartConfirmed().then(() => {
          setReloading(false)
          onRestart()
        })
      }
    })
  }

  return (
    <button
      className="btn btn-secondary btn-block"
      onClick={onRestartRequest}
    >
      {
        reloading ? (
          <>
            <div className="spinner-border spinner-border-sm text-light mr-2"></div>
            Reloading the device
          </>
        ) : (
          <>
            <i className="fal fa-power-off mr-2"></i>
            Restart Video Window
          </>
        )
      }


    </button>
  )
}
